import { Component } from '@angular/core';

@Component({
  selector: 'app-cards4-examples-26',
  templateUrl: './cards4-examples-26.component.html'
})
export class Cards4Examples26Component {}
